import { ChevronLeft } from "lucide-react";
import type { ReactNode } from "react";
import { cn } from "@/lib/cn";
import {
  MOBILE_PRO_CHROME_FORM_HEADER_CLASS,
  MOBILE_PRO_CHROME_TITLE_CLASS,
  MOBILE_PRO_CHROME_TOP_ROW_CLASS,
  MOBILE_PRO_CHROME_TRAILING_CLASS,
} from "./mobile-pro-chrome";

export interface MobileProFormTopBarProps {
  title: string;
  onBack: () => void;
  trailing?: ReactNode;
  className?: string;
}

function MobileProFormTopBar({ title, onBack, trailing, className }: MobileProFormTopBarProps) {
  return (
    <header className={cn(MOBILE_PRO_CHROME_FORM_HEADER_CLASS, className)}>
      <div className={MOBILE_PRO_CHROME_TOP_ROW_CLASS}>
        <button
          type="button"
          aria-label="Back"
          onClick={onBack}
          className="-ml-1 flex size-9 shrink-0 items-center justify-center rounded-md text-pro-text hover:bg-pro-elevated"
        >
          <ChevronLeft className="size-5" strokeWidth={2.5} aria-hidden />
        </button>
        <h1 className={cn(MOBILE_PRO_CHROME_TITLE_CLASS, "min-w-0 flex-1")}>{title}</h1>
        {trailing ? <div className={MOBILE_PRO_CHROME_TRAILING_CLASS}>{trailing}</div> : null}
      </div>
    </header>
  );
}

export { MobileProFormTopBar };
